import { ArrowLeft2 } from "iconsax-react";
import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;

  width: 100%;
  padding: 1.5rem;

  border-radius: 0.5rem;
  background: ${({ theme }) => theme.checkoutStepsOffers?.cardBackground};

  @media (max-width: 375px) {
    padding: 0;
  }
`;

export const WrapperCreditCardInputs = styled.div`
  display: grid;
  align-items: flex-end;
  justify-content: center;

  gap: 1rem;
  grid-template-areas: "number expiration_date cvv";
  grid-template-columns: 1fr 5.625rem 5.625rem;

  width: 100%;
  margin: 0 0 1rem;

  .expiration_date {
    grid-area: expiration_date;
  }

  .cvv {
    grid-area: cvv;
  }

  @media (max-width: 875px) {
    .expiration_date,
    .cvv {
      input,
      div {
        margin: 0;
      }
    }

    grid-template-areas:
      "number number"
      "expiration_date cvv";

    grid-template-columns: 1fr 1fr;
  }
`;

export const ReturnToCardListButton = styled.button`
  display: flex;
  align-items: center;

  margin: 0 0 1.5rem;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;

  border: none;
  background: none;
  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};

  transition: 300ms ease-in-out;

  &:hover {
    transform: translateX(-0.125rem);
  }
`;

export const ArrowLeftIcon = styled(ArrowLeft2)`
  margin: 0 0.625rem 0 0;

  size: 1.25rem;
  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
`;
